import { Stack, StackProps, Box } from '@mui/system';
import { Types } from '@scorenco/core';

export enum WinStatus {
  Win = 2,
  Even = 1,
  Lost = 0,
}

type CompetitionRankingColumnSerieProps = StackProps & {
  ranking?: Types.Competitions_Ranking_Detail;
};

export const CompetitionRankingColumnSerie = ({
  ranking,
  sx,
  ...rest
}: CompetitionRankingColumnSerieProps) => {
  const serie = ranking?.serie?.length
    ? ranking.serie
    : [null, null, null, null, null];

  return (
    <Stack
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        flex: '0 0 6rem',
        ...sx,
      }}
      {...rest}
    >
      {serie?.map((win_status, idx) => {
        if (idx > 4) {
          return null;
        }

        if (win_status === WinStatus.Win) {
          return (
            <Box
              key={idx}
              sx={{
                padding: '1.5px 4px',
                borderRadius: '5px',
                color: 'win.contrastText',
                fontSize: '0.65rem',
                backgroundColor: 'win.main',
              }}
            >
              V
            </Box>
          );
        }

        if (win_status === WinStatus.Lost) {
          return (
            <Box
              key={idx}
              sx={{
                padding: '1.5px 4px',
                borderRadius: '5px',
                color: 'lost.contrastText',
                fontSize: '0.65rem',
                backgroundColor: 'lost.main',
              }}
            >
              D
            </Box>
          );
        }

        if (win_status === WinStatus.Even) {
          return (
            <Box
              key={idx}
              sx={{
                padding: '1.5px 4px',
                borderRadius: '5px',
                color: 'even.contrastText',
                fontSize: '0.65rem',
                backgroundColor: 'even.main',
              }}
            >
              N
            </Box>
          );
        }

        return (
          <Box
            key={idx}
            sx={{
              padding: '1.5px 4px',
              borderRadius: '5px',
              color: 'even.contrastText',
              fontSize: '0.65rem',
              backgroundColor: 'even.main',
            }}
          >
            ?
          </Box>
        );
      })}
    </Stack>
  );
};
